import { documentReady } from './utils';

import AOS from 'aos';

const Animations = {
    initialize: () => {

        documentReady(() => {
            AOS.init({
                once: true
            });
        });
    },
}

Animations.initialize();

export default Animations;
